module.exports = __webpack_public_path__ + "img/thumb_05.30ed3e69.jpg";